import styled, {css} from 'styled-components';

import {Button} from '@edna/components';
import {mixins} from '@edna/components/styles';

export const Container = styled.div`
  position: relative;
  width: 100%;
`;

export const Code = styled.div`
  ${mixins.scroll({isInverse: true, isWide: true})}
  width: 100%;
  max-width: 100%;
  max-height: 500px;
  overflow: auto;
  ${({theme}) => css`
    padding: 0 ${theme.spacing.s2};
    background: ${theme.palette.grey50};

    ::-webkit-scrollbar {
      height: ${theme.spacing.s2};
    }
  `};
`;

export const FloatingButton = styled(Button)`
  position: absolute;
  top: ${({theme}) => theme.spacing.s4};
  right: ${({theme}) => theme.spacing.s4};
  z-index: 1;
`;

const rowHeight = '22px';

type TEditorContainerProps = {
  isInvalid?: boolean;
  disabled?: boolean;
  readOnly?: boolean;
  rows: number;
};

export const EditorContainer = styled.div<TEditorContainerProps>`
  position: relative;
  width: 100%;
  padding: 0;

  ${({theme, rows}) => css`
    line-height: ${rowHeight};

    ::-webkit-scrollbar {
      height: ${theme.spacing.s2};
    }

    /* stylelint-disable-next-line  selector-class-pattern */
    .editor-content {
      ${mixins.scroll({isInverse: true, isWide: true})};
      ${mixins.input}

      /* top & bottom margins + rows height - top & bottom borders */
      height: calc(${theme.spacing.s4} * 2 + ${rowHeight} * ${rows} - ${theme.dimensions
        .borderWidth}px * 2);
      overflow: auto;
      padding: ${theme.spacing.s3} ${theme.spacing.s4};
    }

    pre {
      margin: 0;
    }

    .select {
      background-color: ${theme.branding.backgrounds.primary};
      padding: ${theme.spacing.s1};
      border-radius: 2px;
    }
  `};
`;
